import React from "react";
import { X, Lock, Globe, Store } from "lucide-react";

const ICONS_MAP = {
  INTERNAL: Lock,
  EXTERNAL: Globe,
  ONLINE: Store,
};

/**
 * Strip auto-generated "Markup X% - " / "Diskon X% - " / "Markup Rp X - " prefix
 * from description so only the user's custom description part is shown.
 */
function cleanDescription(type) {
  const raw = (type.description || "").trim();
  if (!raw) return "";

  // If jenis is set (Markup / Diskon), description from old code was:
  //   "{jenis} {nilai}{satuan} - {user_description}"
  // OR the whole thing was: "Markup 10%" with no extra part.
  // Strip the leading "Markup X..." or "Diskon X..." portion up to " - " if present.
  const cleaned = raw
    .replace(/^(Markup|Diskon)\s+[\d.,]+[%]?\s*(-\s*)?/i, "")
    .replace(/^(Markup|Diskon)\s+Rp\s+[\d.,]+\s*(-\s*)?/i, "")
    .replace(/^Harga normal tanpa diskon atau markup\s*(-\s*)?/i, "")
    .trim()
    .replace(/^-\s*/, "")
    .trim();

  return cleaned;
}

export default function SalesTypeModal({ salesTypes = [], onSelect, onClose }) {
  const getIcon = (slug) => ICONS_MAP[slug] || Store;

  return (
    <div
      onClick={onClose}
      className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center backdrop-blur-sm p-4 modal-backdrop-enter">
      <div
        onClick={(e) => e.stopPropagation()}
        className="bg-white rounded-2xl w-full max-w-md p-6 shadow-2xl modal-panel-enter">
        <div className="flex items-center justify-between mb-2">
          <h2 className="text-xl font-bold text-gray-800">Tipe Penjualan</h2>
          {onClose && (
            <button
              onClick={onClose}
              className="p-1 hover:bg-gray-100 rounded-full">
              <X className="w-5 h-5 text-gray-500" />
            </button>
          )}
        </div>
        <p className="text-gray-500 mb-6">
          Pilih salah satu tipe sesuai kebutuhan transaksi Anda
        </p>

        <div className="space-y-3">
          {salesTypes.map((type) => {
            const Icon = getIcon(type.slug);
            const desc = cleanDescription(type);
            return (
              <button
                key={type.id}
                onClick={() => onSelect(type)}
                className="w-full flex items-center gap-4 p-4 border border-gray-200 rounded-xl hover:border-teal-500 hover:bg-teal-50 transition-all group text-left">
                <div className="w-12 h-12 rounded-full bg-teal-100 flex items-center justify-center text-teal-600 group-hover:bg-teal-600 group-hover:text-white transition-colors shrink-0">
                  <Icon className="w-6 h-6" />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="font-bold text-gray-800">{type.name}</h3>
                  {desc && (
                    <p className="text-sm text-gray-500 truncate mt-0.5">
                      {desc}
                    </p>
                  )}
                </div>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
